module.exports = __webpack_public_path__ + "img/payment-check-circle.98c0b597.svg";